
export enum NON_TRANSFERABLE_TYPE {
  DOOR_CONTROLLER = "DOOR_CONTROLLER",
}

export enum NON_TRANSFERABLE_PROVIDER {
  MASTERLOCK = "MASTERLOCK",
  URMET = "URMET",
}
